module.exports = __webpack_public_path__ + "static/media/thum3.d2724a1d.jpg";